import { CarbonIconType } from "@carbon/icons-react";
import React, { useState } from "react";
import { ToolTip } from "../../atom/Tooltip";
import { cn } from "../../../utils/styles";

interface DocumentsActionButtonProps {
  label: string;
  icon: CarbonIconType;
  disabled?: boolean;
  onClick?: () => void;
}

export const DocumentsActionButton: React.FC<DocumentsActionButtonProps> = ({
  onClick,
  icon: Icon,
  disabled,
  label,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={onClick}
        className={cn(
          "w-8 h-8 flex items-center justify-center text-gray-550 disabled:text-gray-550 disabled:opacity-50 rounded-[3px]",
          !disabled && "hover:bg-gray-100 hover:text-black",
        )}
        disabled={disabled}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}>
        <Icon size={20} />
      </button>
      {tooltipVisible && <ToolTip text={label} type="nav" position="top" />}
    </div>
  );
};
